import { FormField, Input, Form, Grid, GridRow, GridColumn, Dropdown } from 'semantic-ui-react';
import { ConfigProps } from '../constants';

function WeightInput({ label, onChange, value }) {
    return <FormField control={Input} label={label} onChange={(e) => onChange(e.target.value)} value={value} />;
}

function QuantityPerformanceConfig({ config, tableTypes, onChange }) {
    function onPropChange(prop, newVal) {
        onChange({ ...config, [prop]: newVal });
    }

    function getWeightField(label, prop) {
        return <WeightInput label={label} onChange={(v) => onPropChange(prop, v)} value={config[prop]} />;
    }

    return (
        <>
            <Form>
                <br />
                <Grid columns={6} divided>
                    <GridRow>
                        <GridColumn>
                            Weight per Update
                            {getWeightField('IS', ConfigProps.UPDATE_IS_PER_CELL_W)}
                            {getWeightField('KPIs', ConfigProps.UPDATE_KPI_PER_CELL_W)}
                            {getWeightField('Other', ConfigProps.UPDATE_OTHER_PER_CELL_W)}
                            {getWeightField('Mistake Detection Scale', ConfigProps.MD_UPDATE_SCALE)}
                        </GridColumn>
                        <GridColumn>
                            Weight per FC Review
                            {getWeightField('IS', ConfigProps.FC_IS_PER_CELL_W)}
                            {getWeightField('KPIs', ConfigProps.FC_KPI_PER_CELL_W)}
                            {getWeightField('Other', ConfigProps.FC_OTHER_PER_CELL_W)}
                        </GridColumn>
                        <GridColumn>
                            Weight per CD Review
                            {getWeightField('IS', ConfigProps.CD_IS_PER_CELL_W)}
                            {getWeightField('KPIs', ConfigProps.CD_KPI_PER_CELL_W)}
                            {getWeightField('Other', ConfigProps.CD_OTHER_PER_CELL_W)}
                        </GridColumn>
                        <GridColumn>
                            Weight per VC Review
                            {getWeightField('IS', ConfigProps.VC_IS_PER_CELL_W)}
                            {getWeightField('KPIs', ConfigProps.VC_KPI_PER_CELL_W)}
                            {getWeightField('Other', ConfigProps.VC_OTHER_PER_CELL_W)}
                        </GridColumn>
                        <GridColumn>
                            Target max mistakes per Table Type
                            {getWeightField('Updates', ConfigProps.T_MISTAKES_FOR_R_UPDATE)}
                            {getWeightField('Full Check Review', ConfigProps.T_MISTAKES_FOR_F_C_REVIEW)}
                            {getWeightField('Core Data Check Review', ConfigProps.T_MISTAKES_FOR_C_D_C_REVIEW)}
                        </GridColumn>
                        <GridColumn>
                            Table types to include
                            <Form.Field>
                                <label>Table Types </label>
                                <Dropdown
                                    onChange={(a, b) => onPropChange('tableTypes', b.value)}
                                    value={config.tableTypes}
                                    placeholder="Table Types"
                                    options={tableTypes.map((t) => {
                                        return { key: t, text: t, value: t };
                                    })}
                                    multiple
                                    selection
                                    search
                                />
                            </Form.Field>
                        </GridColumn>
                    </GridRow>
                </Grid>
            </Form>
        </>
    );
}

export default QuantityPerformanceConfig;
